<template>
  <v-container class="ma-0">
    <div class="mx-3 mb-4">
      <v-row>
        <v-dialog
          v-model="dialog"
          max-width="400"
        >
          <template #activator="{ on }">
            <v-btn v-on="on">
              Create Achievement
            </v-btn>
          </template>

          <v-card>
            <v-card-title class="headline">
              Create an achievement
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="title"
                label="Title"
                counter="50"
                required
                autofocus
              />
              <span class="font-weight-bold">Note.</span> Information are changed later.
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                text
                @click="dialog = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                text
                type="submit"
                :disabled="loading"
                @click="createAchievement"
              >
                Create
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-spacer />
        <v-switch
          v-model="showPublic"
          label="Show Public Achievements"
        />
      </v-row>
      <v-row>
        <TagList
          v-if="showPublic"
          class="mx-4"
          :tags="availableTags"
          @selected-tags="selectedTags"
        />
      </v-row>
    </div>

    <AchievementRow
      v-for="achievement in achievements"
      :key="achievement.id"
      :achievement="achievement"
      :read-only="achievement.ownerId != user.uid"
      @click="editAchievement(achievement.id)"
    />
    <v-btn
      v-if="isMore && !filterTags"
      block
      @click="page += 1"
    >
      Next
    </v-btn>
  </v-container>
</template>

<script>
import firebase from 'firebase/app';
import { db } from '@/firebase';

import AchievementRow from '@/components/achievements/AchievementRow.vue';

import TagList from '@/components/TagList.vue';
import achievementsTags from '@/config/achievement-tags.js';

const pageSize = 20;

export default {
  name: 'AchievementList',
  components: {
    AchievementRow,
    TagList,
  },
  data() {
    return {
      title: '',
      dialog: false,
      availableTags: achievementsTags,
      tags: [],
      achievements: [],
      showPublic: false,
      page: 1,
      isMore: true,
      lastVisible: null,
    };
  },
  computed: {
    error() {
      return this.$store.getters.error;
    },
    loading() {
      return this.$store.getters.loading;
    },
    user() {
      return this.$store.getters.user;
    },
    filterTags() {
      return this.tags.length > 0;
    },
  },

  watch: {
    page: {
      immediate: true,
      handler(val, oldVal) {

        if (this.page === 1 && this.lastVisible === null) {
          // First time load
          this.$bind('achievements', db.collection('achievements')
            .where('ownerId', '==', this.user.uid)
            .orderBy('createdAt', 'desc')
            .limit(pageSize));
        } else {
          // Load more
          if (!this.showPublic) {
            this.$bind('achievements', db.collection('achievements')
              .where('ownerId', '==', this.user.uid)
              .orderBy('createdAt', 'desc')
              .startAfter(this.lastVisible)
              .limit(pageSize));
          } else {
            this.$bind('achievements', db.collection('achievements')
              .where('public', '==', true)
              .startAfter(this.lastVisible)
              .limit(pageSize));
          }
        }
      },
    },

    showPublic: {
      handler(val, oldVal) {
        // Reset pagination
        this.page = 1;
        this.isMore = true;
        this.lastVisible = null;

        if (val === true) {
          this.$bind('achievements', db.collection('achievements')
            .where('public', '==', true)
            .limit(pageSize));
        } else {
          this.$bind('achievements', db.collection('achievements')
            .where('ownerId', '==', this.user.uid)
            .orderBy('createdAt', 'desc')
            .limit(pageSize));
        }
      },
    },

    tags: {
      handler(val, oldVal) {
        if (this.tags.length > 0) {
          this.$bind('achievements', db.collection('achievements')
            .where('tags', 'array-contains-any', this.tags).where('public', '==', true));
        }
      },
    },

    achievements: {
      handler(val, oldVal) {
        const newAchievements = val;

        if (newAchievements.length === 0) return; // Ignore this

        if (newAchievements.length === pageSize) {
          this.isMore = true;
        } else if (newAchievements.length < pageSize) {
          this.isMore = false;
        } 

        const lastVisibleId = newAchievements[newAchievements.length - 1].id;

        db.collection('achievements')
          .doc(lastVisibleId)
          .get()
          .then((snapshot) => {
            this.lastVisible = snapshot;
          });

      },
    },
  },

  methods: {
    editAchievement(achievementId) {
      this.$router.push(`/achievements/${achievementId}`);
    },
    createAchievement() {
      this.$store.commit('setLoading', true);
      this.$store.commit('clearError');

      db.collection('achievements')
        .add({
          title: this.title,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          ownerId: this.user.uid,
          image: null,
          type: 'image',
          public: false,
          successPercentage: 0, // Default success percentage, can be changed later
        })
        .then((docRef) => {
          this.$store.commit('setLoading', false);
          this.$store.commit('clearError');
          this.$router.push(`/achievements/${docRef.id}`);
        })
        .catch((error) => {
          console.error('Error adding document: ', error);
        });
    },

    selectedTags(tags) {
      this.tags = tags;
    },
  },

};
</script>
